import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import {AppLayout} from '@amzn/awsui-components-react';
import ICIntegrationApp from './ICIntegrationApp';
import ICIntegrationRestrict from './ICIntegrationRestrict';
import Navigation from 'common/navigation';
import 'regenerator-runtime/runtime'
import 'babel-polyfill';
import {ensureAuthenticated} from 'utils/auth';
import {loginSuccess, loginFailure} from 'actions';
import '@amzn/awsui-components-react/index.css';

import {Provider} from 'react-redux';
import configureStore from './store';
import {DragDropContextProvider} from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

const store = configureStore({});

function startICIntegrationApp() {
  ensureAuthenticated()
    .then((auth) => {
      store.dispatch(loginSuccess(auth));
      ReactDOM.render(
        <Provider store={store}>
          <BrowserRouter>
            <DragDropContextProvider backend={HTML5Backend}>
              <div className="awsui">
                <AppLayout
                  content={<ICIntegrationApp/>}
                  navigation={<Navigation/>}
                  contentType="default"
                  toolsHide
                  navigationOpen={false}
                />
              </div>
            </DragDropContextProvider>,
          </BrowserRouter>,
        </Provider>,
        document.getElementById('root')
      );
    })
    .catch((e) => {
      console.log('ensureAuthenticated threw an exception: ', e);
      store.dispatch(loginFailure(e));
      ReactDOM.render(
        <BrowserRouter>
          <ICIntegrationRestrict/>
        </BrowserRouter>,
        document.getElementById('root'),
      );
    });
}

startICIntegrationApp();